import { ClientLayerError } from 'shared/errors/clientLayerError'

/** Logged when fetching agency listing filters fails. */
export class FetchAgencyFiltersError extends ClientLayerError {
  static readonly className: string = 'FetchAgencyFiltersError'

  constructor(error: unknown) {
    super(error, { cause: error })
    this.setMarkupOptions({ scope: 'agency', section: 'listing' })
    this.addFingerprintSegment('fetch-agency-filters')
  }
}
